import React, { useState } from "react";

import AssetSchemaSelect from "../../../AssetSchemaSelect";
import ImportSourceName from "../../../ImportSourceName";
import ObjectTypeNameInput from "../../../ObjectTypeNameInput";
import SectionMessage from "@atlaskit/section-message";
const UserAssetStart = () => {
  return (
    <>
      <br />
      <SectionMessage title="Information" appearance="info">
        <p>
          Select the Asset schema and name the import source and object type
          used for the import.
        </p>
      </SectionMessage>
      <br />
      <AssetSchemaSelect />
      <ImportSourceName defaultImportSourceName="JiraUserImport"/>
      <p></p>
      <ObjectTypeNameInput defaultName={"Jira Users"} />
    </>
  );
};
export default UserAssetStart;
